<template>
  <div class="filter-wrapper">
    <el-form ref="form" :inline="true" v-model="listQuery" >
      <el-form-item label="快速搜索" v-if="filterItem.searchBox">
        <el-select :size="size" v-model="searchCanteen" value-key="canteen_id" filterable :filter-method="searchFilter"
                   placeholder="请选择">
            <el-option
              filterable
              placeholder="快速搜索餐厅"
              v-for="canteen in allCanteenListFiltered"
              :key="canteen.canteen_id"
              :label="`食堂: ${canteen.eatery_name} ---- 餐厅: ${canteen.canteen_name}`"
              :value="canteen">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="日期" v-if="filterItem.datetime">
        <el-date-picker
          :size="size"
          :clearable="false"
          @change="setListQuery"
          v-model="listQuery.datetime"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="filterItem.dateRange" label="日期">
        <el-date-picker
          :size="size"
          :clearable="false"
          :picker-options="pickerOptions2"
          @change="setListQuery"
          v-model="listQuery.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          :size="size"
          :picker-options="pickerOptions2"
          @change="setListQuery"
          :clearable="false"
          v-if="filterItem.datetimeRange"
          v-model="listQuery.datetimeRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="filterItem.eatery" label="食堂">
        <el-select
          :size="size"
          required
          style="width: 150px"
          class="filter-item"
          value-key="eatery_id"
          v-model="listQuery.eatery"
          placeholder="食堂选择"
          @change="setListQuery"
        >
          <el-option
            v-for="eatery in eateryList"
            :key="eatery.eatery_id"
            :label="eatery.eatery_name"
            :value="eatery"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="filterItem.canteen" label="餐厅">
        <el-select
          :size="size"
          required
          style="width: 150px"
          class="filter-item"
          value-key="canteen_id"
          v-model="listQuery.canteen"
          placeholder="餐厅选择"
          @change="handleCanteenChange"
        >
          <el-option
            v-for="canteen in canteenList"
            :key="canteen.canteen_id"
            :label="canteen.canteen_name"
            :value="canteen"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="filterItem.machine" label="机器">
        <el-select
          :size="size"
          required
          style="width: 150px"
          class="filter-item"
          value-key="machine_id"
          v-model="listQuery.machine"
          placeholder="餐厅选择"
          @change="setListQuery"
        >
          <el-option
            v-for="machine in machineList"
            :key="machine.machine_id"
            :label="`id-${machine.machine_id}-${machine.machine_name}`"
            :value="machine"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// eslint-disable-next-line
import {mapActions, mapGetters} from 'vuex';
// eslint-disable-next-line
import {apiGetMachineList} from '@/api';
import pinyinMatch from 'pinyin-match';

export default {
  name: 'filterWrapper',
  components: {},
  props: {
    size: {
      type: String,
      default: 'mini'
    },
    filterItem: {
      type: Object,
      default () {
        return {
          dateRange: true,
          datetime: true,
          eatery: true,
          canteen: true,
          machine: true,
          datetimeRange: true,
          searchBox: true
        };
      }
    }
  },
  data () {
    return {
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchCanteen: '',
      allCanteenListFiltered: []
    };
  },
  async mounted () {
    // this.$store.commit('setListQuery'
    //  等待查询所有餐厅
    await this.setAllCanteenList();
    this.allCanteenListFiltered = this.allCanteenList;
  },
  computed: {
    ...mapGetters([
      'allCanteenList',
      'listQuery',
      'canteenList',
      'machineList'
    ]),
    eateryList () {
      return this.$store.state.global.eateryList;
    },
    userinfo () {
      return this.$store.getters.userinfo();
    },
    api_key () {
      return this.userinfo.api_key;
    },
    searchOptions () {
      // return [];
      console.log(this.allCanteenList);
      return this.allCanteenList;
    }
  },
  methods: {
    ...mapActions([
      'setCanteenList',
      'setAllCanteenList'
    ]),
    searchFilter (text) {
      // console.log(text);
      let res = this.allCanteenList.filter(a => {
        let res = pinyinMatch.match(a.canteen_name + ',' + a.eatery_name, text);
        return res.length > 0;
      });
      if (!text) {
        this.allCanteenListFiltered = this.allCanteenList;
      } else {
        this.allCanteenListFiltered = res;
      }
    },
    setListQuery (e) {
      // this.$store.dispatch('setListQuery', {listQue
      // ry: this.listQuery})
      this.searchCanteen = null;
      if (e && e.eatery_count !== undefined) {
        console.log('saaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
        // this.setCanteenList && this.setCanteenList();
        this.$store.dispatch('setCanteenList');
      }
      this.$store.dispatch('setListQuery', this.listQuery);
    },
    async handleCanteenChange () {
      try {
        let machineList = await apiGetMachineList({apiKey: this.apiKey, canteen_id: this.listQuery.canteen.canteen_id});
        this.$store.commit('setMachineList', machineList);
        this.listQuery.machine = this.machineList[0];
        this.$store.dispatch('setListQuery', this.listQuery);
      } catch (e) {
        console.log(e);
      }
    },
    async getAllCanteenList () {
    }
  },
  watch: {
    searchCanteen: {
      handler (val) {
        let listQuery = this.listQuery;
        listQuery.canteen = {
          canteen_id: val.canteen_id,
          canteen_name: val.canteen_name
        };
        listQuery.eatery = {
          eatery_id: val.eatery_id,
          eatery_name: val.eatery_name
        };
        this.$store.dispatch('setListQuery', listQuery);
        this.$store.dispatch('setCanteenList', {isSearch: true});
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin: 0!important;
}
.filter-wrapper {
  display: block;
  width: 100%;
  padding: 5px;
}
</style>
